import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer1GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Оситивка"
        attackSignal="ocitivka_attack"
        healSignal="ocitivka_heal"
        attackDescription="Дождь из летучих мышей. Урон 5."
        healDescription="Ноты появляются по всему полю. Лечение 4."
    />
);
